import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useHistory } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import { taxRateService } from "../../Services/taxRate.service";
import ResultModal from "../Common/ResultModal";
import { useTranslation } from "react-i18next";
import SpinnerLoading from "../Common/SpinnerLoading";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import { roles } from "../../Config/Roles";
import Tooltip from "../Common/Tooltip";

const Index = () => {
  const { t: translator } = useTranslation();
  const { updateLocTab, updateLocName, isMobile } = useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const { master, admin } = roles;
  const [taxRates, setTaxRates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });
  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });
  const [update, setUpdate] = useState(new Date());
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchName, setSearchName] = useState("");
  const history = useHistory();

  useEffect(() => {
    updateLocName("tax-rates");
    taxRateService
      .get({
        searchName,
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      })
      .then((res) => {
        setTaxRates(res.data.taxRates);
        setPagination({ ...pagination, totalCount: res.data.totalCount });
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err.response);
      });
    updateLocTab(0);
  }, [update, searchName]);

  const handleToAdd = () => {
    history.push("/tax-rate-add");
  };

  const handleClose = () => {
    setModal({ show: false });
    history.push("/tax-rates");
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPagination({
      ...pagination,
      pageIndex: page - 1,
      pageSize: sizePerPage,
    });
    setUpdate(new Date());
  };

  const RemoteAll = ({ data, page, sizePerPage, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        remote
        keyField="taxRateId"
        data={data}
        columns={columns}
        noDataIndication={translator("No-Data")}
        /* rowEvents={rowEvents} */
        rowClasses="boostrap-table-row"
        pagination={paginationFactory({
          page,
          sizePerPage,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  const columns = [
    {
      dataField: "name",
      text: translator("TaxRates-TableHeader-Name"),
    },
    {
      dataField: "value",
      text: translator("TaxRates-TableHeader-Value"),
    },
  ];

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("TaxRates-Subtitle-TaxRatesView")}</span>
          {[master, admin].includes(Number(roleId)) && (
            <button
              className={
                "btn btn-primary float-right" + (isMobile ? " btn-sm" : "")
              }
              onClick={handleToAdd}
            >
              {" "}
              <span
                className="icon icon-cancel web-hidden"
                style={{ transform: "rotate(45deg)" }}
              ></span>
              <span className="mob-hidden">
                {translator("TaxRates-View-AddTaxRate")}
              </span>
            </button>
          )}
        </div>

        <div
          style={{ margin: 5, marginTop: "10px" }}
          className="alert alert-warning"
          role="alert"
        >
          {translator("TaxRate-InfoMsg")}
        </div>

        <div className="card-body">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("TaxRates-Filters")}
            </legend>
            <form
              className="row"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <div className="form-group col-lg-3 col-md-4 col-xs-12">
                <label>{translator("TaxRates-FiltersName")}</label>{" "}
                <Tooltip text={translator("TaxRateTooltip-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  value={searchName}
                  onChange={(event) => {
                    setSearchName(event.target.value);
                    setPagination({ ...pagination, pageIndex: 0 });
                  }}
                />
              </div>
            </form>
          </fieldset>

          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={taxRates}
              page={pagination.pageIndex + 1}
              sizePerPage={pagination.pageSize}
              totalSize={pagination.totalCount}
              onTableChange={handleTableChange}
            />
          )}
        </div>
      </div>

      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </div>
  );
};

export default Index;
